import type {TenantFeatureConfig} from "../types/tenant";
import type {TernaryFlagValue} from "../components/feature-flags/TernaryFeatureFlag";

export type EffectiveFlag =
        | {source: "override"; value: boolean}
        | {source: "global"; value: boolean}
        /** Inherited, but no global default exists: inheritance does not imply on. */
        | {source: "unset"; value: null};

/** Mirrors the backend: a stored true/false wins; null or absent takes the global default when one exists. */
export function effectiveFlag(stored: boolean | null | undefined, globalDefault: boolean | undefined): EffectiveFlag {
    if (stored === true || stored === false) return {source: "override", value: stored};
    if (globalDefault === true || globalDefault === false) return {source: "global", value: globalDefault};
    return {source: "unset", value: null};
}

export type OverrideSummary = {on: number; off: number; inherit: number};

export function summarizeOverrides(config: TenantFeatureConfig, flags: readonly string[]): OverrideSummary {
    const summary: OverrideSummary = {on: 0, off: 0, inherit: 0};
    for (const flag of flags) {
        const value = config[flag];
        if (value === true) summary.on += 1;
        else if (value === false) summary.off += 1;
        else summary.inherit += 1;
    }
    return summary;
}

/** One click in the flag matrix: inherit → on → off → inherit. */
export function nextMatrixValue(value: TernaryFlagValue): TernaryFlagValue {
    if (value === null) return true;
    if (value === true) return false;
    return null;
}

/** Reads a stored boolean flag; anything that is not an explicit override is inheritance. */
export function storedFlagValue(config: TenantFeatureConfig, flag: string): TernaryFlagValue {
    const value = config[flag];
    return value === true || value === false ? value : null;
}
